export default __webpack_public_path__ + "static/media/hero-banner.8aee002e.png";